import React, { Component, PropTypes } from 'react';
import { Row, Col, Button, Modal, Spin, Select, Radio, Alert, Input, Form } from 'antd';

import { browserHistory } from 'react-router';
import { formItemLayout } from 'constants/layout';
import _ from 'lodash';
import cn from 'classnames';
// import ClassSchedulesTab from './ClassSchedules';
// import ClassReviewsTab from './ClassReviews';

import { connect } from 'react-redux';

import { getWithdrawById, editWithdrawal, paidWithdraw, rejectWithdraw } from 'data/transaction';

import Utils from 'utils/utils';

import WithdrawalInfoHeader from './WithdrawalInfoHeader';
import WithdrawalDetail from './WithdrawalDetail';

import classes from '../styles/withdrawal/WithdrawalInfo.module.scss';

// const SubMenu = Menu.SubMenu;
// const MenuItemGroup = Menu.ItemGroup;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const { Option, OptGroup } = Select;
const { TextArea } = Input;

class WithdrawalInfo extends Component {
  constructor(props) {
    super(props);

    // props.getAutocompleteTeachers(props.classroom.owner.displayName);

    this.state = {
      collapseMobile: [],
      mode: 'editor',
    };
  }

  componentDidMount = async () => {
    const promises = [];
    const id = this.props.params.withdrawalId;
    console.log(id);
    this.setState({
      loading: true,
    });
    const withdrawal = await getWithdrawById(id);

    this.setState({
      loading: false,
      withdrawal,
    });

    return Promise.all(promises);
  };

  onToggleMode() {
    const mode = this.state.mode === 'editor' ? 'preview' : 'editor';
    this.setState({
      mode,
    });
  }
  handleSubmit = () => {
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const editedWithdrawal = _.merge(values, {});
        editWithdrawal(_.get(this.state, 'withdrawal._id'), editedWithdrawal).then(async () => {
          // browserHistory.push('/withdraw');
          await this.reload();
          this.setState({
            isShowRemarkModal: false,
          });
        });

        console.log('Received values of form: ', values);
      }
    });
  };

  reload = async () => {
    this.setState({
      loading: true,
    });
    const withdrawal = await getWithdrawById(_.get(this.state, 'withdrawal._id'));

    this.setState({ withdrawal, loading: false });
  };

  isDisabledBtn = () => {
    if (this.state.withdrawal.status === 'paid' || this.state.withdrawal.status === 'rejected') {
      return true;
    }
    return false;
  };

  handlePaid = () => {
    if (this.isDisabledBtn()) {
      return;
    }
    this.setState({
      loading: true,
    });
    paidWithdraw(_.get(this.state, 'withdrawal._id')).then(() => {
      // getWithdrawById(_.get(this.state, 'withdrawal._id'));
      this.reload();
    });
  };

  handleReject = () => {
    if (this.isDisabledBtn()) {
      return;
    }
    this.setState({
      loading: true,
    });
    rejectWithdraw(_.get(this.state, 'withdrawal._id')).then(() => {
      // getWithdrawById(_.get(this.state, 'withdrawal._id'));
      this.reload();
    });
  };

  renderEditRemarkModal() {
    const { getFieldDecorator } = this.props.form;
    console.log(this.state.isShowRemarkModal);

    return (
      <Modal
        title={'Edit Remark'}
        visible={this.state.isShowRemarkModal}
        onCancel={() => this.setState({ isShowRemarkModal: false })}
        footer={[
          <Button key="back" size="large" onClick={() => this.setState({ isShowRemarkModal: false })}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" size="large" loading={this.state.loading} onClick={this.handleSubmit}>
            Save
          </Button>,
        ]}
      >
        <Form onSubmit={this.handleSubmit}>
          <FormItem {...formItemLayout} label="Remark" hasFeedback>
            {getFieldDecorator('remark', {
              initialValue: this.state.withdrawal.remark,
            })(<TextArea />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }

  renderTabs() {
    return <div />;
  }

  render() {
    // console.log(this.state.files);
    const { withdrawal, loading } = this.state;
    if (!withdrawal) {
      return <div></div>;
    }

    return (
      <div>
        <Spin tip="Loading" size="large" spinning={!!loading}>
          <div className="page-header">
            {this.props.BreadCrumb}
            <WithdrawalInfoHeader onOpenRemarkModal={() => this.setState({ isShowRemarkModal: true })} withdrawal={withdrawal} Tabs={this.renderTabs()} />
          </div>
          <WithdrawalDetail withdrawal={this.state.withdrawal} loading={this.state.loading} />
          {this.renderEditRemarkModal()}
          <div className={cn('content')}>
            <Row>
              <Col xs={11} className={'text-right'}>
                <Button type="danger" size="large" onClick={this.handleReject} loading={this.state.loading} disabled={this.isDisabledBtn()}>
                  Reject
                </Button>
              </Col>
              <Col xs={2} />

              <Col xs={11} className={'text-left'}>
                <Button type="success" size="large" onClick={this.handlePaid} loading={this.state.loading} disabled={this.isDisabledBtn()}>
                  Paid
                </Button>
              </Col>
            </Row>
          </div>
        </Spin>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    // pages: state.content.pages,
    // withdrawal: state.transaction.withdrawal,
  }),
  {},
)(Form.create()(WithdrawalInfo));
